import { QueryObserverOptions } from "@tanstack/react-query"

import { Duration } from "@shared/types/duration"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { makeFileInstance } from "./generic/FileInstance"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: Duration.days(1).milliseconds,
  gcTime: Duration.days(1).milliseconds,
  refetchOnWindowFocus: false,
}

/** Fetches the care group's public-page illustration image */
export const getIllustration = (id: string, version?: string) =>
  axiosPublic({
    url: `/public/care-groups/${id}/illustration${version ? `?v=${version}` : ""}`,
    method: "get",
    responseType: "blob",
    timeout: 5000,
  }).then(makeFileInstance)
